import React from 'react';
import './faq-css.css';

const FAQ = () => (
    <div id="faq-div-1a">
        Viral campaigns are tracked in shared cloud spreadsheets that feature
        links to live Tweets/posts, archived images of results, detailed stats,
        and transparent cost-efficiency analytics.
        <br/>
        <br/>
        Viral accepts: PayPal, ACH, wire, BTC, checks
        <br/>
        <br/>
        Viral does not sell retweets.
        <br/>
        Viral categorically does not use + despises any/all kinds of artificial/monetary advertising incentives.
        <br/>
        Viral does not sell followers.
        <br/>
        <br/>
        Viral targets + optimizes for one thing and one thing only:
        cost-efficient content engagement. We chase ideals, not $.
    </div>
);

export default FAQ;


// WEBPACK FOOTER //
// ./src/components/info/faq/Faq.js